import { useState, useEffect } from 'react';
import config from '../../config/config';
import Header from '../directives/header';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  Tab,
  Nav,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../directives/footer';
import '../css/unitronixexplained.css';
import Subscription from './subscribe.js';
import { getUnitronixexplainedAction } from '../../apis/apiAction.js';

const UnitronixExplained = () => {
  const [positionClass, setPositionClass] = useState('relative');
  const [BannerData, setBannerData] = useState([]);

  
    useEffect(() => {
      getBannerData();
    }, []);
  
    const getBannerData = async () => {
      try {
        let res = await getUnitronixexplainedAction()
        if (res.data) {
          setBannerData(res.data);
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    };

  useEffect(() => {
    const updatePosition = () => {
      setPositionClass(window.innerWidth >= 767 ? 'absolute' : 'relative');
    };

    updatePosition(); // Set initial state
    window.addEventListener('resize', updatePosition);

    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return (
    <>
      <Header />
      <main style={{ paddingTop: '80px' }}>
        <section className="unitronixexplained position-relative">
          <Container className="">
            <Row className="">
              <Col lg={6} className="">
                <div className="heading mb-4">
                  <h1 className="text-white text-uppercase fw-bold mb-0">
                    Who We Are 
                  </h1>
                </div>
                <p>
                 {BannerData.whoWeAreDescription}
                </p>
                {/* <p>
                  Unitronix is at the forefront of revolutionizing the digital
                  and financial landscapes, leveraging cutting-edge blockchain
                  technology. With a mission to transform the internet and
                  financial systems, we aim to eliminate inefficiencies, reduce
                  reliance on intermediaries, and connect parties directly
                  through smart contracts. By providing secure, efficient, and
                  transparent solutions, Unitronix empowers investors,
                  innovators, and institutions while making the crypto space
                  more accessible to all and paving the way for a more inclusive
                  and sustainable economy.
                </p>
                <p>
                  Unitronix is dedicated to simplifying and democratizing access
                  to digital asset investments. As a publicly traded company, we
                  bridge the gap between traditional finance and decentralized
                  finance (DeFi), enabling investors to benefit from exposure to
                  diversified digital assets, including Bitcoin, Ethereum,
                  high-growth altcoins, debt instruments and tokenized
                  real-world assets (RWAs), without the complexities.
                </p> */}
              </Col>
              <Col lg={6} className="mb-4">
                <div className="WhoAreImg">
                  <div className={`position-${positionClass} end-0`}>
                    <img src="assets/images/whoareyou.svg" width={`100%`} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="missionvision py-0">
          <Container>
            <Row>
              <Col lg={6} className="mb-4">
                <Card className="blueCard">
                  <Card.Body className="p-0">
                    <div>
                      <div className="p-4 z-1">
                        <h2 className="my-2 text-white">The Mission</h2>
                        <p className="my-4">
                          {/* To empower global investors with secure, transparent,
                          and optimized access to the crypto economy by
                          leveraging blockchain, AI, and innovative financial
                          technologies. */}
                          {BannerData.missionDescription}
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6} className="mb-4">
                <Card className="blueCard">
                  <Card.Body className="p-0">
                    <div>
                      <div className="p-4 z-1">
                        <h2 className="my-2 text-white">
                          The Vision: Transforming the Future with Smart
                          Contracts
                        </h2>
                        <p className="my-4">
                        {/* To lead the next generation of blockchain-driven
                        investments, transforming how individuals and
                        institutions engage with digital and tokenized assets. */}
                          {BannerData.visionDescription}
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="corevalue ">
          <Container>
            <Row>
              <Col lg={12} className="mb-5">
                <div className="text-center">
                  <div className="">
                    <h1 className="my-2 text-white">Our Core Values</h1>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="">
                <Row>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/bulb.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">Innovation</h4>
                            <p>
                              {/* We drive blockchain evolution with cutting-edge
                              investment and tokenization solutions */}
                              {BannerData.innovation}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/transparent.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">Transparency</h4>
                            <p>
                              {/* We prioritize trust through blockchain-based
                              security and compliance. */}
                              {BannerData.transparency}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/accessibility.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">Accessibility</h4>
                            <p>
                              {' '}
                              {/* We break down barriers, making crypto investments
                              seamless for all investors. */}
                              {BannerData.accessibility}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/security.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">Security</h4>
                            <p>
                              {' '}
                              {/* We integrate decentralized and automated
                              protections into our systems. */}
                              {BannerData.security}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col lg={12} className="">
                <div className="tabStyle5">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="first"
                  >
                    <Row className="align-items-center">
                      <Col xl={6} className="mb-5">
                        <Nav variant="pills" className="flex-column">
                          <Nav.Item>
                            <Nav.Link eventKey="first" className="p-4">
                              {/* Unitronix envisions a future where the majority of
                              the world's interactions, including traditional
                              processes and intermediary-driven transactions,
                              are replaced by smart contracts. By eliminating
                              inefficiencies, reducing reliance on middlemen,
                              and fostering direct connections between parties,
                              we aim to create systems that are more secure,
                              automated, and efficient. */}
                              {BannerData.coreValueFirstDescription}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="second" className="p-4">
                              {/* To reach this ambitious goal, Unitronix is
                              committed to making smart contracts as robust,
                              flexible, and capable as traditional systems. This
                              vision is powered by blockchain technology,
                              combined with cutting-edge software engineering,
                              enabling the creation of ecosystems where assets
                              can be securely tokenized, managed, and
                              transparently transferred. */}
                              {BannerData.coreValueSecondDescription}
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </Col>
                      <Col xl={6} className="mb-5">
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <div className="px-xxl-5">
                              <img
                                src="assets/images/tab1.svg"
                                className="w-100"
                              />
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <div className="px-xxl-5">
                              <img
                                src="assets/images/tab1.svg"
                                className="w-100"
                              />
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>
                </div>
                {/* <Row>
                  <Col lg={12} className="mb-5">
                  
                    <Card className="border rounded-5">
                      <Card.Body className="p-md-5 ">
                        <div className="p-3 text-center">
                          <p className="">Unitronix envisions a future where the majority of the world's interactions, including traditional processes and intermediary-driven transactions, are replaced by smart contracts. By eliminating inefficiencies, reducing reliance on middlemen, and fostering direct connections between parties, we aim to create systems that are more secure, automated, and efficient.</p>
                          <p className="mb-0">To reach this ambitious goal, Unitronix is committed to making smart contracts as robust, flexible, and capable as traditional systems. This vision is powered by blockchain technology, combined with cutting-edge software engineering, enabling the creation of ecosystems where assets can be securely tokenized, managed, and transparently transferred.</p>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                </Row> */}
              </Col>
            </Row>
          </Container>
        </section>

        <section className="whatwedo py-0">
          <Container>
            <Row>
              <Col lg={12} className="mb-5">
                <div className="text-center">
                  <div className="">
                    <h1 className="mb-4 text-white">What We Do</h1>
                    <p>
                      {/* Unitronix enables investors to gain exposure to digital
                      assets and RWAs without direct ownership by offering : */}
                      {BannerData.whatWeDoHeading}
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="">
                <Row className="">
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div>
                          <ul>
                            <li className="mb-4">
                              {/* <b className="text-white">
                                Cryptocurrency Investment Portfolio :
                              </b>{' '}
                              A professionally managed portfolio providing
                              exposure to Bitcoin, Ethereum, altcoins, and
                              stablecoins. */}
                              {BannerData.whatWeDoDescription1}
                            </li>

                            <li className="mb-4">
                              {/* <b className="text-white">Tokenized Assets :</b>{' '}
                              Investments in RWAs, debt instruments,
                              intellectual property, corporate equity, and
                              structured finance products powered by blockchain. */}
                              {BannerData.whatWeDoDescription2}
                            </li>

                            <li className="mb-4">
                              {/* <b className="text-white">
                                Smart Contract & Blockchain Innovations :
                              </b>{' '}
                              systems that automate asset management cycle and
                              financial transactions. */}
                              {BannerData.whatWeDoDescription3}
                            </li>

                            <li className="">
                              {/* <b className="text-white">
                                Decentralized Finance (DeFi) Integration :
                              </b>{' '}
                              Yield-generating opportunities, second market
                              trading, and liquidity solutions via tokenized
                              RWAs and Debt Instruments. */}
                              {BannerData.whatWeDoDescription4}
                            </li>
                          </ul>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="">
                          <div className="">
                            <img
                              src="assets/images/whatwedo.jpg"
                              className="object-fit-contain"
                            />
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
        <Subscription Why_Unitronix ={BannerData.whyUnitronixDescription} joinUsDescription={BannerData.joinUsDescription}/>
        {/* <section className="getintouch pt-0">
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="mb-4 text-center">
                <div className="heading mt-4">
                  <h1 className="mb-4 text-white">Why Unitronix?</h1>
                  <p>
                    Unlike traditional crypto investment platforms,{' '}
                    <b className="text-white">Unitronix Corp.</b> offers{' '}
                    <b className="text-white">
                      secure, regulated exposure to digital assets
                    </b>{' '}
                    through our{' '}
                    <b className="text-white">publicly traded stock (UTRX),</b>{' '}
                    eliminating the complexities of wallets, private keys, and
                    direct blockchain interactions. With AI-driven risk
                    management, smart contract automation and security
                    mechanism,{' '}
                    <b className="text-white">
                      Unitronix simplifies crypto investing for everyone—from
                      retail investors to asset managers and institutional
                      funds.
                    </b>
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="mb-4 text-center">
                <Card>
                  <Card.Body>
                    <Row className="getContent justify-content-center align-items-center">
                      <Col lg={9} className=" text-center">
                        <div>
                          <div className="mb-4">
                            <h1 className="fw-semibold text-white mb-0">
                              Join Us in the Future of Digital Investments
                            </h1>
                          </div>
                          <p className="mb-4">
                            Unitronix invites investors, innovators, and
                            institution to collaborate in shaping the future of
                            tokenized assets and decentralized finance.
                          </p>
                          <Button className="text-black">Get In Touch</Button>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                  <div>
                    <div className="rightshadow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="811"
                        height="276"
                        viewBox="0 0 811 276"
                        fill="none"
                      >
                        <g filter="url(#filter0_f_522_5675)">
                          <path
                            d="M470.316 274.271C489.094 152.693 662.22 78.5233 799.097 99.6645C935.973 120.806 1031.71 236.502 1012.93 358.08C1004.54 412.402 926.154 430.79 883.506 463.512C830.704 504.024 806.814 551.632 731.095 539.937C661.618 529.206 671.813 466.334 633.13 418.476C595.604 372.049 461.069 334.138 470.316 274.271Z"
                            fill="#5646AC"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_f_522_5675"
                            x="0.920868"
                            y="-372.861"
                            width="1483.3"
                            height="1383.54"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="BackgroundImageFix"
                              result="shape"
                            />
                            <feGaussianBlur
                              stdDeviation="234.47"
                              result="effect1_foregroundBlur_522_5675"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </div>
                    <div className="particleImg">
                      <img src="assets/images/particle.gif" />
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </section> */}
      </main>

      <Footer />
    </>
  );
};
export default UnitronixExplained;
